import Page from 'src/event/[entityId]/embed/interaction/index';

export default Page;
